module.exports = __webpack_public_path__ + "img/logo.c9010486.svg";